import React, { useEffect, useState } from 'react';
import './PatientsAndFamilies.scss'
import '../../../pages/styles.scss'
import Patients1 from '../../../../assets/images/WhoWeHelp/patients-1.png'
import Patients1ForMobile from '../../../../assets/images/WhoWeHelp/patients-responsive.png'
import Clinics from '../../../../assets/images/WhoWeHelp/clinics.png'
import tagSvg from '../../../../assets/images/WhoWeHelp/tag.svg'
import Ijections from '../../../../assets/images/WhoWeHelp/injections.jpg'
import CommonInsuranceSection from '../../../../components/reusable/HomePageSections/CommonInsuranceSection/CommonInsuranceSection.js';
import FooterSection from '../../../../components/reusable/HomePageSections/FooterSection/FooterSection.js';
import { faqDataForSkilledNursingFacilities } from '../../../../components/reusable/Common/Constant.js';
import FAQAccordionSection from '../../../../components/reusable/CommonSection/FAQAccordionSection/FAQAccordionSection.js';

const PatientsAndFamilies = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [currentImage, setCurrentImage] = useState(Patients1);

    useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        setCurrentImage(windowWidth <= 898 ? Patients1ForMobile : Patients1);
    }, [windowWidth]);
    return (
        <div className='patients-and-families-container container'>
            <div className='patients-and-families-section section-1'>
                <div className='patients-and-families-section-content text'>
                    <h1>For Patients and <span className="highlight">Families</span></h1>
                    <p>We focus on providing specialized rehabilitation and pain management services through Acute Care Hospitals, Inpatient Rehab Facilities, and Skilled Nursing Facilities. While we work directly with healthcare providers, we aim to improve patient outcomes by offering personalized, physician-led care plans designed to enhance recovery, manage pain, and increase independence. Patients and their families can expect comprehensive support from our expert team of providers, all working to ensure the best possible care in partnership with the facility.</p>
                    <div className='button-section'>
                        <a className='btn' href="/contact-us">
                            <i className='bx bx-plus'></i>
                            Contact Us
                        </a>
                    </div>
                </div>
                <div className='patients-and-families-section-content'>
                    <div className='image-container'>
                        <img src={currentImage} alt="" />
                    </div>
                </div>
            </div>
            <div className='patients-and-families-section section-2'>
                <div className='patients-and-families-section-content'>
                    <div className='image-container'>
                        <img src={Clinics} alt="" />
                    </div>
                </div>
                <div className='patients-and-families-section-content text'>
                    <div className='tag' style={{
                        backgroundImage: `url(${tagSvg})`,
                    }}>
                        <span>Our Goal</span>
                    </div>
                    <h1>Here for You</h1>
                    <p>We focus on connecting providers, patients, and families with a strong emphasis on collaboration. Our goal is to help aging individuals maintain their independence and quality of life through personalized, expert care that supports their needs in partnership with the facilities where they reside.</p>
                </div>
            </div>
            <div className='patients-and-families-section section-3'>
                <div className='patients-and-families-section-content text'>
                    <div className='company-vision-title'>
                        <div className='tag' style={{
                            backgroundImage: `url(${tagSvg})`,
                        }}>
                            <span>Services</span>
                        </div>
                        <br />
                        <h1>Dedicated Care for Individuals. Support for Families.</h1>
                    </div>
                    <div className='company-vision-para'>
                        <p>Traditional healthcare often overlooks the unique needs of aging individuals, but Virginia Rehab Physicians places patient health and wellness at the core of our services. We offer specialized care designed to enhance quality of life, supported by advanced technology. Through collaboration with healthcare providers, we ensure a comprehensive approach to patient care, empowering both patients and their families.</p>
                    </div>
                </div>
                <hr className="section-divider" />
                <div className='patients-and-families-section-content text'>
                    <div className='company-vision-point'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M36.5692 7.37491C38.4473 7.37491 39.9685 5.72321 39.9685 3.68746C39.9685 1.65171 38.4473 0 36.5692 0C34.6926 0 33.1699 1.65171 33.1699 3.68746C33.1699 5.72477 34.6926 7.37491 36.5692 7.37491ZM36.5938 18.1095H25.5022C23.6212 18.1095 22.0957 16.4547 22.0957 14.4143C22.0957 12.3738 23.6212 10.719 25.5022 10.719H36.5952C38.4762 10.719 40.0017 12.3738 40.0017 14.4143C40.0017 16.4547 38.4748 18.1095 36.5938 18.1095ZM14.4534 28.8144H36.5934C38.4744 28.8144 39.9999 27.1595 39.9999 25.1191C39.9999 23.0787 38.4744 21.4238 36.5934 21.4238H14.4534C12.5724 21.4238 11.0469 23.0787 11.0469 25.1191C11.0469 27.1595 12.5724 28.8144 14.4534 28.8144ZM3.40649 40.0001H36.5935C38.4745 40.0001 40 38.3453 40.0014 36.3049C40.0014 34.2644 38.4759 32.6096 36.5949 32.6096H3.40649C1.52551 32.6096 0 34.2644 0 36.3049C0 38.3453 1.52551 40.0001 3.40649 40.0001Z" fill="url(#paint0_linear)"></path><defs><linearGradient id="paint0_linear" x1="0" y1="0" x2="40" y2="51.5" gradientUnits="userSpaceOnUse"><stop stopColor="#FA9081"></stop><stop offset="1" stopColor="#FBD647"></stop></linearGradient></defs></svg>
                        <h2>Access to Specialized Care</h2>
                    </div>
                    <div className='company-vision-point'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M39.9999 3.40649V36.5935C39.9999 38.4759 38.3451 40 36.3046 40C34.2642 40 32.6094 38.4745 32.6094 36.5935V3.40649C32.6094 1.52551 34.2642 0 36.3046 0C38.3451 0 39.9999 1.52551 39.9999 3.40649ZM28.8143 14.4534V36.5934C28.8143 38.4758 27.1595 39.9999 25.1191 39.9999C23.0786 39.9999 21.4238 38.4744 21.4238 36.5934V14.4534C21.4238 12.5724 23.0786 11.0469 25.1191 11.0469C27.1595 11.0469 28.8143 12.5724 28.8143 14.4534ZM18.1092 36.5935V25.5005C18.1092 23.6195 16.4544 22.094 14.414 22.094C12.3736 22.094 10.7188 23.6195 10.7188 25.5005V36.5935C10.7188 38.4745 12.3736 40 14.414 40C16.4544 40 18.1092 38.4759 18.1092 36.5935ZM7.37489 36.569C7.37489 38.4471 5.72319 39.9683 3.68744 39.9683C1.65014 39.9683 0 38.4456 0 36.569C0 34.6923 1.65014 33.1697 3.68744 33.1697C5.72475 33.1697 7.37489 34.6909 7.37489 36.569Z" fill="url(#paint0_linear)"></path><defs><linearGradient id="paint0_linear" x1="0" y1="0" x2="40.0003" y2="51.4982" gradientUnits="userSpaceOnUse"><stop stopColor="#FA9081"></stop><stop offset="1" stopColor="#FBD647"></stop></linearGradient></defs></svg>
                        <h2>Empowered by Technology</h2>
                    </div>
                    <div className='company-vision-point'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="41" viewBox="0 0 38 41" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M13.2872 34.5298V26.437H5.47231C2.45038 26.437 0 23.9866 0 20.9647C0 17.9427 2.45038 15.4944 5.47231 15.4944H13.2872V5.4723C13.2872 2.45038 15.7376 0 18.7574 0C21.7773 0 24.2297 2.45038 24.2297 5.4723V20.152C24.2693 20.4172 24.2897 20.6885 24.2897 20.9647C24.2897 21.2409 24.2693 21.5123 24.2297 21.7776V34.5298C24.2297 37.5517 21.7794 40.0021 18.7574 40.0021C15.7355 40.0021 13.2872 37.5517 13.2872 34.5298ZM32.5171 26.3762C35.5099 26.3762 37.9353 23.9507 37.9353 20.9579C37.9353 17.9651 35.5099 15.5396 32.5171 15.5396C29.5242 15.5396 27.0988 17.9651 27.0988 20.9579C27.0988 23.9507 29.5242 26.3762 32.5171 26.3762Z" fill="url(#paint0_linear)"></path><defs><linearGradient id="paint0_linear" x1="0" y1="0" x2="40.4769" y2="49.4195" gradientUnits="userSpaceOnUse"><stop stopColor="#FA9081"></stop><stop offset="1" stopColor="#FBD647"></stop></linearGradient></defs></svg>
                        <h2>Stronger Together</h2>
                    </div>
                </div>
            </div>
            <div className='patients-and-families-section section-4'>
                <div className='patients-and-families-section-content text'>
                    <div className='company-vision-title'>
                        <h1>Aging persons need specialized care</h1>
                    </div>
                </div>
                <hr className="section-divider" />
                <div className='patients-and-families-section-content text'>
                    <div className='company-vision-point one'>
                        <span>81<span className="percent-sign">%</span></span>
                        <h3>of hospitalizations in elderly are from falls</h3>
                    </div>
                    <div className='company-vision-point two'>
                        <span>20-30<span className="percent-sign">%</span></span>
                        <h3>Risk of death within 1 year post hip fracture</h3>
                    </div>
                </div>
            </div>
            {/* <div className='patients-and-families-section section-5'>
                <div className='patients-and-families-section-content image'>
                    <div className='image-container'>
                        <img src={Ijections} alt="" />
                    </div>
                </div>
                <div className='patients-and-families-section-content text'>
                    <h1>How Joint Injections Impact Recovery</h1>
                    <p>Everything you need to know about joint injections and how they can be used in the treatment of pain related to osteoarthritis.</p>
                    <div className='button-section'>
                        <a className='btn-2' href="">
                            <i className='bx bx-right-arrow-alt' />
                            Find a Meaningful Career
                        </a>
                    </div>
                </div>
            </div> */}
            <FAQAccordionSection faqData={faqDataForSkilledNursingFacilities} />
            <CommonInsuranceSection />
            <FooterSection />
        </div>
    )
}

export default PatientsAndFamilies
